<template>
  <div class="cookie-consent">
    <b-modal v-model="is_modal_active" :can-cancel="true" :aria-modal="true">
      <section class="hero is-small p-1" style="background: linear-gradient(to right, rgb(26, 30, 88), rgb(44, 51, 147));">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="columns">
              <div class="column" style="display: flex; flex-wrap: wrap; place-content: center; align-items: center;">
                <h3 class="subtitle is-4" style="color: rgb(242, 243, 243);">
                  Subscribe to our newsletter and get our exclusive <a href="/e-shop/how-to-become-engineer" style="color: #baff00;">How to Become a Licensed Part-66 Engineer</a> training for free!
                </h3>
              </div>
            </div>
            <div class="columns">
              <div class="column" style="display: flex; flex-wrap: wrap; place-content: center; align-items: center;">
                <div>
                  <subscribe button_class="button is-info is-light is-large is-fullwidth" @subscribed="closeModal"></subscribe>
                  <br>
                  <span class="is-clickable" style="color: rgb(242, 243, 243);" @click="closeModal">No thanks, I'm not interested</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </b-modal>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'SubscriptionBonusPopup',
  data() {
    return {
      is_modal_active: true
    };
  },
  mounted() {
    this.markModalAsSeen();
  },
  methods: {
    closeModal() {
      this.is_modal_active = false;
    },
    markModalAsSeen() {
      axios.post('/newsletters/mark-subscription-bonus-popup-as-seen');
    }
  }
};
</script>
